import React from "react";

interface ToggleLoginModalProps {
  modalId: string;
  onConfirm: () => void;
  isEnabling: boolean;
}

const ToggleLoginModal: React.FC<ToggleLoginModalProps> = ({
  modalId,
  onConfirm,
  isEnabling,
}) => {
  return (
    <div className="modal fade" id={modalId}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h4 className="modal-title">
              {isEnabling ? "Enable" : "Disable"} Login
            </h4>
            <button
              type="button"
              className="btn-close custom-btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              id="toggle_login_modal_close"
            >
              <i className="ti ti-x" />
            </button>
          </div>
          <div className="modal-body">
            <p>
              Are you sure you want to {isEnabling ? "enable" : "disable"} login
              for this user?{" "}
              {isEnabling
                ? "This will allow the user to log in."
                : "This will prevent the user from logging in."}
            </p>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-outline-light border me-2"
              data-bs-dismiss="modal"
            >
              Cancel
            </button>
            <button
              type="button"
              className={`btn ${isEnabling ? "btn-success" : "btn-danger"}`}
              onClick={onConfirm}
            >
              {isEnabling ? "Enable" : "Disable"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ToggleLoginModal;
